// extracted by mini-css-extract-plugin
export default {"blockContainer":"BlockStyles_blockContainer__2R-cP","flexBox":"BlockStyles_flexBox__oRDpT","dots":"BlockStyles_dots__mpdE4","viewAllLink":"BlockStyles_viewAllLink__9uhnl"};